// extracted by mini-css-extract-plugin
export default {"mCard":"vF-z","image":"wF-z","imageNoBackground":"xF-z","fullWidth":"yF-z"};